var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCloudSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.58 63.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c3135;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.44,60.64c5.29-1.82,10.94-5.97,9.38-10.36,13.02,3.09,27.41,2.69,40.58-1.11,25.2-7.28-1.16-41.53-27.16-25.86C142.52-4.77,38.96-2.75,20.57,5.06c-57.8,24.55,23.12,70.99,36.94,47.73,11.71,9.47,29.67,13.42,45.93,7.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCloudSmall);
export default __webpack_public_path__ + "static/media/green-cloud-small.a2731265b2a5a5af9afad072a0d9d379.svg";
export { ForwardRef as ReactComponent };